class AskAiButton extends HTMLElement {
  constructor() {
    super();
    this.buttonEl = null;
    this.searchInput = null;
    this.init();
  }

  init() {
    this.innerHTML = `
      <button type="button" class="ask-ai-button" aria-label="Ask AI">
        <span class="ask-ai-button__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="31" height="26" viewBox="0 0 31 26" fill="none">
            <path d="M9.07479 7.7039L8.65133 6.41363C8.5395 6.07286 8.0586 6.06961 7.94216 6.40883L7.49626 7.70791C7.45891 7.81673 7.37357 7.9023 7.26486 7.93994L5.88287 8.41842C5.55115 8.53328 5.54609 9.00058 5.87524 9.1226L7.27177 9.64029C7.37611 9.67897 7.4578 9.76209 7.49467 9.86708L7.94224 11.1415C8.06018 11.4774 8.53622 11.4742 8.64968 11.1368L9.07491 9.87244C9.11116 9.76467 9.19445 9.67923 9.30127 9.64027L10.7144 9.12483C11.0458 9.00398 11.041 8.53371 10.7073 8.41954L9.3091 7.94117C9.19812 7.9032 9.11137 7.81536 9.07479 7.7039Z" fill="#282F3C"/>
            <path d="M21.0862 10.6263L20.1359 7.73075C19.8849 6.96601 18.8057 6.95871 18.5444 7.71998L17.5437 10.6353C17.4599 10.8795 17.2684 11.0716 17.0244 11.156L13.923 12.2298C13.1786 12.4876 13.1673 13.5363 13.9059 13.8101L17.04 14.9719C17.2741 15.0587 17.4574 15.2452 17.5402 15.4808L18.5446 18.3409C18.8093 19.0946 19.8776 19.0875 20.1322 18.3303L21.0865 15.4929C21.1678 15.251 21.3548 15.0593 21.5945 14.9718L24.7658 13.8151C25.5094 13.5439 25.4988 12.4885 24.7499 12.2323L21.612 11.1588C21.363 11.0736 21.1683 10.8764 21.0862 10.6263Z" fill="#282F3C"/>
          </svg>
        </span>
        <span class="ask-ai-button__text">Search with AI</span>
      </button>
    `;

    this.buttonEl = this.querySelector('.ask-ai-button');
    this.bindEvents();
  }

  bindEvents() {
    if (!this.buttonEl) return;

    this.buttonEl.addEventListener('click', this.handleClick.bind(this));

    const form = this.closest('form');
    if (form) {
      this.searchInput = form.querySelector('[data-search-input]');

      if (this.searchInput) {
        this.searchInput.addEventListener('input', this.handleSearchInput.bind(this));
      }
    }
  }

  handleSearchInput(event) {
    // Hide the button if there's any text in the search input
    if (this.searchInput.value.trim()) {
      this.buttonEl.style.display = 'none';
    } else {
      this.buttonEl.style.display = 'flex';
    }
  }

  handleClick() {
    // Just open the chat modal without a specific query
    if (window.sendGreenbackMessage) {
      window.sendGreenbackMessage({
        trigger: 'default',
        source: 'header search',
      });
    } else {
      console.warn('Preezie AI integration not available: window.sendGreenbackMessage is not defined');
    }
  }
}

customElements.define('ask-ai-button', AskAiButton);
